<template>
  <div class="flex flex-col place-items-center">
    <img src="../../assets/logo_trans.png" class="h-20 p-4" />
    <p class="font-opensans">Wachtwoord vergeten</p>
    <div
      class="border border-mi-blue-500 shadow-lg p-8 rounded-lg m-2 max-w-md"
    >
      <FormulateForm class="input" @submit="requestPassword">
        <FormulateInput
          type="text"
          name="email"
          v-model="email"
          validation="required"
          :wrapper-class="['login-wrapper-class']"
          input-class="bg-gray-200 border border-transparent rounded-md w-full
        px-2 mb-3 focus:border-mi-blue-600 focus:bg-white placeholder-black
        placeholder-opacity-100"
          aria-placeholder="E-mail"
          placeholder="E-mail"
          :validation-messages="{ required: 'E-mail is verplicht' }"
        />

        <FormulateInput
          label="Vraag aan"
          type="submit"
          input-class="bg-mi-blue-500 text-center rounded-lg text-white w-full mt-4"
        />
      </FormulateForm>
      {{ this.msg }}
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ForgotPassword",
  data() {
    return {
      email: "",
      msg: null
    };
  },
  computed: {
    loggedIn: function() {
      return this.$store.getters.current_user;
    }
  },
  methods: {
    requestPassword: function() {
      this.$store.dispatch("requestPassword", this.email);
      this.msg =
        "U ontvangt een e-mail met een link om uw wachtwoord opnieuw in te stellen.";
      setTimeout(this.redirectToLogin, 3000);
    },
    redirectToLogin: function() {
      this.$router.push("/login");
    },
    ...mapActions(["logout"])
  },
  watch: {
    loggedIn() {
      if (this.loggedIn && this.$router.currentRoute.name !== "Home") {
        this.$router.push("/");
      }
    }
  }
};
</script>

<style>
.login-wrapper-class {
  @apply block;
}
</style>
